import { CampaignBlocks } from "@kvix/shared";
import { Container, Grid, makeStyles } from "@material-ui/core";
import React, { useContext } from "react";
import { Button } from "../../Inputs";
import { Text } from "../../Primitives";
import { AdminFormFilePicker, AdminFormInput } from "../admin";
import { AdminCampaignContentContext } from "../context/adminCampaignContentContext";
const useStyles = makeStyles((theme) => ({
    centerContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "750px"
    },
    profileImg: {
        margin: "40px 0 20px 0",
        borderRadius: "50%",
        height: "120px",
        width: "120px",
        [theme.breakpoints.up("sm")]: {
            margin: "40px 0 10px 0"
        }
    },
    firstTitle: { paddingBottom: "5px", color: theme.palette.primary.main },
    button: {
        margin: "20px 0 ",
        padding: "0 20px ",
        height: "44px",
        borderRadius: "30px",
        textTransform: "capitalize",
        "&:active": {
            animation: "$scaleButton linear 300ms "
        },
        "&:hover": {
            background: theme.palette.primary.main
        },
        [theme.breakpoints.up("sm")]: {
            margin: "20px 0 40px 0"
        }
    },
    "@keyframes scaleButton": {
        "0%": {
            transform: "scale(1)"
        },
        "50%": {
            transform: "scale(1.1)"
        },
        "100%": {
            transform: "scale(1)"
        }
    },
    headerImg: {
        height: "100%",
        width: "100%",
        objectFit: "cover"
    }
}));
export class AffiliateCtaWithImgBlock {
    constructor() {
        this.defaultStructure = {
            name: CampaignBlocks.CtaWithImgBlock,
            titles: ["", ""],
            subTitles: [],
            texts: ["", ""],
            buttons: [{ text: "" }],
            media: { images: ["", ""] }
        };
        this.Render = (props) => {
            const { block, campaignContext } = props;
            const classes = useStyles();
            const onClick = () => {
                campaignContext === null || campaignContext === void 0 ? void 0 : campaignContext.openModal(campaignContext);
            };
            return (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, sm: 6, className: classes.centerContainer },
                    React.createElement(Container, { maxWidth: "xs" },
                        React.createElement("img", { className: classes.profileImg, src: block.media.images[0], alt: "" }),
                        React.createElement(Text, { variant: "h1", className: classes.firstTitle }, block.titles[0]),
                        React.createElement(Text, { variant: "h1", style: { paddingBottom: "10px" } }, block.titles[1]),
                        React.createElement(Text, { variant: "h4", style: { paddingBottom: "10px" } }, block.subTitles[0]),
                        React.createElement(Button, { className: classes.button, onClick: onClick }, block.buttons[0].text),
                        React.createElement(Text, { variant: "h6" }, block.texts[0]),
                        React.createElement(Text, { variant: "h6", style: { paddingBottom: "40px" } }, block.texts[1]))),
                React.createElement(Grid, { item: true, sm: 6, className: classes.centerContainer },
                    React.createElement("img", { src: block.media.images[1], className: classes.headerImg, alt: "" }))));
        };
        this.Compose = (props) => {
            const { block } = props;
            const { updateContent } = useContext(AdminCampaignContentContext);
            const titleOnChange = (event) => {
                block.titles[0] = event.target.value;
                updateContent(block);
            };
            const subtitleOnChange = (event) => {
                block.subTitles[0] = event.target.value;
                updateContent(block);
            };
            const textOnChange = (event) => {
                block.texts[0] = event.target.value;
                updateContent(block);
            };
            const buttonTextOnChange = (event) => {
                block.buttons[0].text = event.target.value;
                updateContent(block);
            };
            const filePicker = (file) => {
                block.media.images[0] = file;
                updateContent(block);
            };
            const filePicker2 = (file) => {
                block.media.images[1] = file;
                updateContent(block);
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(AdminFormFilePicker, { name: "image", acceptedFileTypes: ["image/*"], label: "Small Image - recommended size: 120x120 px", folder: "campaign", onChange: filePicker, required: true, file: block.media.images[0] }),
                React.createElement(AdminFormInput, { name: "title", label: "Title", onChange: titleOnChange, required: true, value: block.titles[0] }),
                React.createElement(AdminFormInput, { name: "subtitle", label: "Subtitle", onChange: subtitleOnChange, required: true, value: block.subTitles[0] }),
                React.createElement(AdminFormInput, { name: "text", label: "Small Print", onChange: textOnChange, required: true, value: block.texts[0] }),
                React.createElement(AdminFormInput, { name: "buttonText", label: "Button Text", onChange: buttonTextOnChange, required: true, value: block.buttons[0].text }),
                React.createElement(AdminFormFilePicker, { name: "image", acceptedFileTypes: ["image/*"], label: "Large Image - recommended size: 1000x1000 px", folder: "campaign", onChange: filePicker2, required: true, file: block.media.images[1] })));
        };
    }
}
//# sourceMappingURL=AffiliateCtaWithImgBlock.js.map